import React from 'react';
import { Alert } from '@mui/material';
import { format } from 'date-fns';
import ReservationNavigator from './ReservationNavigator';
import ReservationInfo from './ReservationInfo';
import ScheduleDisplay from './ScheduleDisplay';
import { RESERVATION_VIEWS } from '../constants/editJobConstants';

const ReservationEditForm = ({ 
  reservationError,
  reservationView,
  setReservationView,
  previousReservation,
  nextReservation,
  currentReservationData,
  editingField,
  reservationEditData,
  setReservationEditData,
  onEditField,
  onSaveEdit,
  onCancelEdit,
  affectedJobsCount,
  job
}) => {
  return (
    <div className="space-y-4">
      {reservationError && (
        <Alert severity="error" className="mb-4">
          {reservationError}
        </Alert>
      )}
      
      <ReservationNavigator 
        reservationView={reservationView}
        setReservationView={setReservationView}
        previousReservation={previousReservation}
        nextReservation={nextReservation}
        job={job}
      />
      
      {currentReservationData ? (
        <>
          <ReservationInfo reservation={currentReservationData} />
          
          <ScheduleDisplay 
            reservation={currentReservationData}
            editingField={editingField}
            reservationEditData={reservationEditData}
            setReservationEditData={setReservationEditData}
            onEditField={onEditField}
            onSaveEdit={onSaveEdit}
            onCancelEdit={onCancelEdit}
          />
          
          {/* Impact warnings for current reservation */}
          {reservationView === RESERVATION_VIEWS.CURRENT && affectedJobsCount > 0 && (
            <div className="mt-3 p-3 bg-amber-50 border border-amber-200 rounded-lg">
              <div className="flex items-center">
                <svg className="h-5 w-5 text-amber-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
                <span className="text-sm text-amber-700">
                  Changes to this reservation will affect {affectedJobsCount} job(s).
                </span>
              </div>
            </div>
          )}
          
          {/* Info for previous reservations */}
          {reservationView === RESERVATION_VIEWS.PREVIOUS && job?.serviceType?.timeBase === 'CHECKIN' && (
            <div className="mt-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
              <div className="flex items-center">
                <svg className="h-5 w-5 text-blue-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                </svg>
                <span className="text-sm text-blue-700">
                  This {job.serviceType?.title} job starts when the previous guest checks out. Changes to this checkout time will automatically update the job's start time.
                </span>
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="text-center py-8 text-gray-500">
          <svg className="h-12 w-12 mx-auto mb-3 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <p className="text-sm">
            {reservationView === RESERVATION_VIEWS.PREVIOUS && 'No previous reservation found for this property.'}
            {reservationView === RESERVATION_VIEWS.NEXT && 'No next reservation found for this property.'}
          </p>
        </div>
      )}
    </div>
  );
};

export default ReservationEditForm;